import React, { useEffect, useState } from 'react';
import styles from './TextInput.module.scss';

function TextInput(props: TextInputProps) {

    return (
        <div className={styles.textinput}>
            <p>{props.title}</p>
            <input
                type="text"
                placeholder={props.placeholder}
                onChange={props.onChange} 
                value = {props.value}
                onKeyDown={props.onKeyDown} 
            />
        </div>
    );
}

class TextInputProps {
    onChange?:  ((e: any)=> void)
    onKeyDown?:  ((e: any)=> void)

    title?: string
    value?: string
    placeholder?: string

}

export default TextInput;